module.exports = __webpack_public_path__ + "img/dashboard_my_searches.8f998433.svg";